<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <c-form>
                    <c-form-item type="input" label="活动名称：" name="activity_name"></c-form-item>
                    <c-form-item type="checkbox" label="活动状态：" name="start_state" :options="activityState"></c-form-item>
                    <c-form-item type="checkbox" label="可售范围：" name="visible_user_level" :options="userLevelOptions"></c-form-item>
                </c-form>
            </m-search>

            <m-operate>
                <c-button power="b_activity_secondkill_edit" color="sys" @click="navigateTo('/activity_secondkill_add')">新建活动</c-button>
            </m-operate>

            <c-table ref="table">
                <c-table-column
                        label="活动状态"
                        name="start_state"
                        width="80"
                >
                    <template v-slot="{data}">
                        <span v-if="data.start_state == 0" style="color:#999">{{activityStateText[data.start_state]}}</span>
                        <span v-if="data.start_state == 1" style="color:dodgerblue">{{activityStateText[data.start_state]}}</span>
                        <span v-if="data.start_state == 2" style="color:#999">{{activityStateText[data.start_state]}}</span>
                        <span v-if="data.start_state == 3" style="color:red">{{activityStateText[data.start_state]}}</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="活动名称"
                        name="activity_name"
                        width="200"
                ></c-table-column>
                
                <c-table-column
                        label="可售范围"
                        width="90"
                        name="visible_user_level_name"
                >
                    <template #default="{data}">
                        <span v-if="data.visible_user_level_name && data.visible_user_level_name == '全部会员'" style="color:blue">全部会员</span>
                        <span v-else-if="data.visible_user_level_name" v-for="(item, i) in data.visible_user_level_name.split(',')" :key="i" style="color:darkslategrey;display: block;">{{item}}</span>
                        <span v-else></span>
                    </template>
                </c-table-column>

              <c-table-column
                  label="活动预告"
                  name="activity_notice"
                  width="120"
              >
                <template v-slot="{data}">
                  <span v-if="data.activity_notice == -1" style="color:gray">不预告</span>
                  <span v-if="data.activity_notice == 0" style="color:blue">立即预告</span>
                  <span v-if="data.activity_notice == 1">提前<span style="color:red">{{data.activity_notice_time}}</span>小时预告</span>
                </template>
              </c-table-column>

              <c-table-column
                  label="活动标签"
                  name="tags"
              ></c-table-column>

              <c-table-column
                  label="自动关闭时间(分钟)"
                  name="cancel_time"
              ></c-table-column>

              <c-table-column
                        label="活动时间"
                        width="280"
                >
                    <template v-slot="{data}">{{data.begin_date}} - {{data.end_date}}</template>
              </c-table-column>

              <c-table-column
                        label="创建时间"
                        name="create_date"
                        width="140"
                >
              </c-table-column>
              <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="160"
              >
                    <template v-slot="row">
                        <c-table-button power="b_activity_secondkill_view" @click="navigateTo(`/activity_secondkill_detail/${row.data.id}`)">查看</c-table-button>
                        <c-table-button v-if="row.data.start_state != 1 && row.data.start_state != 2" power="b_activity_secondkill_view" @click="navigateTo(`/activity_secondkill_edit/${row.data.id}`)">修改</c-table-button>
                        <c-table-button power="b_activity_secondkill_state" v-if="row.data.state == 2 && row.data.start_state != 2" @click="disableActivity(row,1)">暂停</c-table-button>
                        <c-table-button power="b_activity_secondkill_state" v-if="row.data.state == 1 && row.data.start_state != 2" @click="disableActivity(row,2)">开始</c-table-button>
                        <c-table-button v-if="row.data.start_state == 0 || row.data.start_state == 2" power="b_activity_secondkill_edit" @click="deleteActivity(row)">删除</c-table-button>
                        <c-table-button power="b_activity_secondkill_view" @click="saleAnalysis(row)">活动销售情况</c-table-button>
                    </template>
              </c-table-column>
            </c-table>

            <c-dialog ref="saleAnalysisDialog"
                      :title="saleAnalysisDialogTitle"
                      width="1200"
                      height="auto"
                      :button="true"
                      :close-button="true"
            >
                <m-search ref="searchSaleAnalysis" @search="searchSaleAnalysisHandle">
                    <c-form>
                        <c-form-item type="datetime" date-type="date" label="统计时间" start-name="start_date" end-name="end_date"></c-form-item>
                    </c-form>
                </m-search>

                <c-table ref="salesAnalysisTable" style="height:600px">
                    <c-table-column label="商品信息" name="order_state" width="400">
                        <template v-slot="{data}">
                            <div style="display: flex;align-items: center;">
                                <c-image width="50px" height="50px" :src="data.product_img_url"></c-image>
                                <div style="margin-left: 10px;width: 80%">
                                    <p style="font-size: 12px;color: #666;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{data.product_name}}</p>
                                    <p style="margin-top: 3px;font-size: 12px;">{{data.product_sku_spec}}</p>
                                </div>
                            </div>
                        </template>
                    </c-table-column>
                    <c-table-column label="商品数量" name="product_count" width="100"></c-table-column>
                    <c-table-column label="商品金额" name="product_money" width="120">
                        <template v-slot="{data}">￥{{ parseFloat(data.product_money).toFixed(2) }}</template>
                    </c-table-column>
                    <c-table-column label="下单时间" name="create_date" width="140"></c-table-column>
                    <c-table-column label="订单号" name="order_number" width="120">
                        <template v-slot="{data}">
                            <p>{{data.order_number}}</p>
                            <p style="margin-top: 2px;" ><a @click="navigateTo(`/order_detail/${data.order_number}`)" power="b_order_detail" style="color: blue">订单详情</a></p></template>
                    </c-table-column>
                </c-table>
            </c-dialog>
        </module>
    </page>
</template>

<script>
    export default {
        name: 'm_activity_secondkill',

        data() {
            return {
                activityState: [
                    {name: '未开始',value: 0},
                    {name: '进行中',value: 1},
                    {name: '暂停中',value: 3},
                    {name: '已结束',value: 2}
                ],
                selectId: '',
                saleAnalysisDialogTitle:'',
                userLevelOptions: []
            }
        },
        computed: {
            activityStateText() {
                var state = {};
                this.activityState.forEach(item => {
                    state[item.value] = item.name;
                });

                return state;
            }
        },

        mounted() {
            this.initUserLevelOptions();
            this.$refs.search.search();
            this.$bus.$on('activitySecondkillList.update', () => {
                this.$refs.search.search();
            });
        },

        methods: {
            //加载会员等级列表
            initUserLevelOptions(){
                this.request({
                    url: '/user_level/options',
                    data: {},
                    success: data => {
                        this.userLevelOptions = Array.from(data, item => {
                            return {
                                name: item.name,
                                value: item.value
                            }
                        });
                    }
                });
            },

            searchHandle(data) {
                this.$refs.table.load({
                    url: '/activitySecondkill/list',
                    data
                });
            },

            disableActivity(item,state) {
                this.$confirm({
                    text: state == 2 ? '确定要开始此秒杀活动吗？' : '确定要暂停此秒杀活动吗',
                    resolve: () => {
                        this.request({
                            url: '/activitySecondkill/updateActivityState',
                            data: {
                                id: item.data.id,
                                state: state
                            },
                            loading: true,
                            success: () => {
                                this.$message({
                                    text: state == 2 ? '开始成功' :'暂停成功'
                                });
                                this.$refs.table.update();
                            },
                            fail: (code, data, msg) => {
                                this.$confirm({
                                    text: msg,  // 提示内容,
                                    buttonName: '知道了',  // 确定按钮文字
                                    cancelButton: false  // 是否显示取消按钮
                                });
                                return false;
                            }
                        });
                    }
                });
            },

            deleteActivity(item) {
                this.$confirm({
                    text: '确定要删除此秒杀活动吗？',
                    resolve: () => {
                        this.request({
                            url: '/activitySecondkill/delete',
                            data: {
                                id: item.data.id
                            },
                            loading: true,
                            success: () => {
                                this.$message({
                                    text: '删除成功'
                                });
                                this.$refs.table.update();
                            }
                        });
                    }
                });
            },

            copyActivity(item) {
                this.request({
                    url: '/activitySecondkill/copy',
                    data: {
                        id: item.data.id
                    },
                    loading: true,
                    success: () => {
                        this.$message({
                            text: '复制成功'
                        });
                        this.$refs.table.update();
                    }
                });
            },
            otherConfig(){
                this.request({
                    url: '/activitySecondkill/config',
                    loading: true,
                    success: (data) => {
                        this.$refs.editForm.clear();
                        this.$refs.editForm.set({"BARGAIN_ACTIVITY_BANNER":data.BARGAIN_ACTIVITY_BANNER,"BARGAIN_ACTIVITY_REMARK":data.BARGAIN_ACTIVITY_REMARK});
                        this.$refs.editDialog.open();
                    }
                });

            },
            submitForm(stop) {
                stop();
                let submitUrl = '/activitySecondkill/updateConfig';
                this.$refs.editForm.submit({
                    url: submitUrl,
                    rule: {
                        BARGAIN_ACTIVITY_BANNER: [{
                            type: 'empty',
                            word: '请上传专区图片'
                        }]
                    },
                    dataFormatter: data => {
                        let configs = [];
                        let banner={},remarks={};
                        banner.id="11";
                        banner.config_item_value= data.BARGAIN_ACTIVITY_BANNER;
                        remarks.id="12";
                        remarks.config_item_value= data.BARGAIN_ACTIVITY_REMARK;
                        configs.push(banner,remarks);
                        data.platform_config_list = configs;
                        return data;
                    },
                    success:(data,res) => {
                        this.$message({
                            text: '操作成功',
                            icon: 'success'
                        });
                        this.$refs.table.update();
                        this.$refs.editDialog.close();
                    },
                });
            },
            saleAnalysis(row) {
                this.selectId = row.data.id;
                this.saleAnalysisDialogTitle = '活动【'+row.data.activity_name+'】销售情况';
                this.$refs.searchSaleAnalysis.search();
                this.$refs.saleAnalysisDialog.open();
            },
            searchSaleAnalysisHandle(data){
                this.$refs.salesAnalysisTable.load({
                    url: '/statistic/activity/productSaleAnalysis',
                    data: {
                        activity_id: this.selectId,
                        ...data
                    }
                });
            }
        }
    }
</script>